import React, { Component } from "react";
import { SortableContainer } from "react-sortable-hoc";

class ImgItemList extends Component {
  render() {
    return <div>{this.props.children}</div>;
  }
}

export default SortableContainer(ImgItemList);



// WEBPACK FOOTER //
// ./src/scenes/NewCase/components/ImgItemList/index.js